module.exports = __webpack_public_path__ + "static/media/ph_beaker_4.af511847.svg";